import { render, staticRenderFns } from "./TabMatrix.vue?vue&type=template&id=21c3fcfa&"
import script from "./TabMatrix.vue?vue&type=script&lang=js&"
export * from "./TabMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports